var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 92,
    height: 92,
    rx: 46,
    fill: "#CF2A2A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 92,
    height: 92,
    rx: 46,
    stroke: "#FFBABA",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5607 32.4393C33.9749 31.8536 33.0251 31.8536 32.4393 32.4393C31.8536 33.0251 31.8536 33.9749 32.4393 34.5607L47.8787 50L32.4397 65.4391C31.8539 66.0248 31.8539 66.9746 32.4397 67.5604C33.0255 68.1462 33.9752 68.1462 34.561 67.5604L50 52.1213L65.4386 67.5599C66.0244 68.1457 66.9741 68.1457 67.5599 67.5599C68.1457 66.9741 68.1457 66.0244 67.5599 65.4386L52.1213 50L67.5602 34.5611C68.146 33.9754 68.146 33.0256 67.5602 32.4398C66.9744 31.854 66.0247 31.854 65.4389 32.4398L50 47.8787L34.5607 32.4393Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.9739db8b659075747db3a5087d8fdfa7.svg";
export { ForwardRef as ReactComponent };